import React from "react";
import { useSelector } from "react-redux";

import { XboxSpinner } from "@gamedev-web/gamedev-sdk-core";

import { getCurrentProgram } from "../../redux/selectors";

export const LoadingSpinner = () => {
  const currentProgram = useSelector(getCurrentProgram);

  const programSpinner = () => {
    switch (currentProgram) {
      default:
        return <XboxSpinner />;
    }
  };
  return programSpinner();
};
